import type { IOption } from "~/types/option";
import { RoiFilterEnum } from "~/types/roi";

export const ROI_TOOLTIP_TEXT =
  "ROI is the total return from entry to resolution, not annualized.";

export const labelByRoiFilterEnum: Record<RoiFilterEnum, string> = {
  [RoiFilterEnum.ALL]: "All",
  [RoiFilterEnum.P5]: ">5%",
  [RoiFilterEnum.P10]: ">10%",
  [RoiFilterEnum.P25]: ">25%",
  [RoiFilterEnum.P50]: ">50%",
  [RoiFilterEnum.P100]: ">100%",
};

export const roiFilterOptions: IOption<RoiFilterEnum>[] = Object.values(
  RoiFilterEnum
).map((value) => ({
  label: labelByRoiFilterEnum[value],
  value,
}));
